<template>
  <div>
    <div v-if="!executions || executions.length === 0" class="text-center py-5">
      <i class="fa fa-line-chart fa-4x text-muted mb-3"></i>
      <p class="text-muted">Nenhuma sincronização registrada ainda</p>
      <small class="text-muted">Execute uma sincronização para visualizar o histórico</small>
    </div>
    <canvas v-else ref="chartCanvas" height="100"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'
import moment from 'moment'

export default {
  name: 'ExecutionChart',
  props: {
    executions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    executions: {
      handler (newVal) {
        if (newVal && newVal.length > 0) {
          this.$nextTick(() => {
            this.renderChart()
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    if (this.executions && this.executions.length > 0) {
      this.$nextTick(() => {
        this.renderChart()
      })
    }
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy()
    }
  },
  methods: {
    renderChart () {
      if (!this.executions || this.executions.length === 0) {
        return
      }

      // Preparar dados (ordem cronológica)
      const sortedExecutions = [...this.executions].sort((a, b) =>
        new Date(a.startTime) - new Date(b.startTime)
      )

      const labels = sortedExecutions.map(exec => {
        const date = moment(exec.startTime)
        return date.format('DD/MM HH:mm')
      })

      const datasets = [
        {
          label: '✅ Criados',
          data: sortedExecutions.map(e => e.createdUsers || 0),
          backgroundColor: '#28a745',
          borderColor: '#28a745',
          borderWidth: 2,
          stack: 'Stack 0'
        },
        {
          label: '🔄 Atualizados',
          data: sortedExecutions.map(e => e.updatedUsers || 0),
          backgroundColor: '#17a2b8',
          borderColor: '#17a2b8',
          borderWidth: 2,
          stack: 'Stack 0'
        },
        {
          label: '❌ Falhas',
          data: sortedExecutions.map(e => e.failedUsers || 0),
          backgroundColor: '#dc3545',
          borderColor: '#dc3545',
          borderWidth: 2,
          stack: 'Stack 0'
        }
      ]

      // Destruir chart anterior se existir
      if (this.chart) {
        this.chart.destroy()
      }

      // Criar novo chart
      const ctx = this.$refs.chartCanvas.getContext('2d')
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            xAxes: [{
              stacked: true,
              gridLines: {
                display: false
              },
              ticks: {
                maxRotation: 45,
                minRotation: 45,
                fontSize: 11,
                fontColor: '#73818f'
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                color: 'rgba(0, 0, 0, 0.05)',
                zeroLineColor: 'rgba(0, 0, 0, 0.2)'
              },
              ticks: {
                beginAtZero: true,
                precision: 0,
                fontSize: 12,
                fontColor: '#73818f'
              },
              scaleLabel: {
                display: true,
                labelString: 'Quantidade de Usuários',
                fontSize: 13,
                fontStyle: 'bold',
                fontColor: '#23282c'
              }
            }]
          },
          legend: {
            display: true,
            position: 'top',
            labels: {
              usePointStyle: true,
              padding: 15,
              fontSize: 12,
              fontColor: '#23282c'
            }
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            titleFontSize: 14,
            titleMarginBottom: 10,
            bodyFontSize: 13,
            bodySpacing: 6,
            xPadding: 12,
            yPadding: 12,
            cornerRadius: 4,
            callbacks: {
              title: function (tooltipItems, data) {
                const index = tooltipItems[0].index
                const exec = sortedExecutions[index]
                return moment(exec.startTime).format('DD/MM/YYYY HH:mm:ss')
              },
              beforeBody: function (tooltipItems, data) {
                const index = tooltipItems[0].index
                const exec = sortedExecutions[index]
                const modeLabels = {
                  'FULL': 'Completa',
                  'MANUAL': 'Manual',
                  'INCREMENTAL': 'Incremental'
                }
                const statusLabels = {
                  'COMPLETED': '✅ Sucesso',
                  'PARTIAL': '⚠️ Parcial',
                  'FAILED': '❌ Falhou'
                }
                return [
                  `Modo: ${modeLabels[exec.mode] || exec.mode}`,
                  `Status: ${statusLabels[exec.status] || exec.status}`,
                  `Iniciada por: ${exec.triggeredBy || '-'}`
                ]
              },
              footer: function (tooltipItems, data) {
                const index = tooltipItems[0].index
                const exec = sortedExecutions[index]
                return `\nTotal: ${exec.totalUsers} usuários`
              }
            }
          },
          hover: {
            mode: 'index',
            intersect: false,
            animationDuration: 200
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ADSync/components/dashboard/ExecutionChart.vue